export const firebaseConfig = {
  apiKey: "AIzaSyAClnK-AlhYl543TvXhebdrImXgLXyJNgg",
  authDomain: "fitness-memo-bc616.firebaseapp.com",
  projectId: "fitness-memo-bc616",
  storageBucket: "fitness-memo-bc616.appspot.com",
  messagingSenderId: "1019900286914",
  appId: "1:1019900286914:web:976c8673c79d1bc58d285b",
  measurementId: "G-6SSPQ8XDLY"
};
